import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleCardTitle = styled.h4<any>`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: ${(props: any) =>
    props?.marginBottom ? props?.marginBottom : 20}px;
  span {
    color: ${(props: any) => props.theme.colors.primary};
  }
  ${(props: any) => props?.customStyle}
`

export const StyleColumn = styled.div<any>`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  ${(props: any) => props.customStyle}
`

export const styleRowWrapper = `
  column-gap:20px;
  width: 100%;
`
export const style30Percent = `
  width:30%;
`
export const style38Percent = `
  width:38%;
`

export const style48Percent = `
  width: 48%;
`

export const style70Percent = `
  width: 70%;
  column-gap:20px;
  row-gap:20px;
  flex-wrap:wrap; 
`
export const style60Percent = `
  width: 60%;
  column-gap:20px;
  row-gap:20px;
  flex-wrap:wrap; 
`

export const style33Percent = `
  width: 33%;
`
export const style28Percent = `
  width: 28%;
`

export const StyleTypography = styled.p<{
  fontSize?: number
  fontWeight?: number
  spanFontSize?: number
  spanFontWeight?: number
  customStyle?: any
  spanColor?: string
}>`
  font-size: ${(props) => props.fontSize || 12}px;
  font-weight: ${(props) => props.fontWeight || 400};
  color: ${(props: any) =>
    props.theme.colors[!!props.color ? props.color : 'black']};

  span {
    font-size: ${(props) => props.spanFontSize || 12}px;
    font-weight: ${(props) => props.spanFontWeight || 400};
    color: ${(props: any) => props.theme.colors[props?.spanColor || 'primary']};
  }

  ${(props) => props.customStyle}
`

export const StyleNoteWrapper = styled.div`
  border-radius: 8px;
  background: ${(props: any) => props.theme.colors.primary50};
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  margin-bottom: 20px;
`
export const cardStyle = `
border-radius : 12px;
 padding: 20px 16px;
`

export const styleButton = ` 
margin-left:auto;
min-width:150px`

export const StyleUserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const StyleCircle = styled.div<{
  size?: number
  bg?: keyof typeof theme.colors
  hasShadow?: boolean
}>`
  width: ${(props) => (props.size ? props.size : 30)}px;
  height: ${(props) => (props.size ? props.size : 30)}px;
  border-radius: 50%;
  background-color: ${(props: any) => props.theme.colors[props.bg || 'white']};
  align-items: center;
  justify-content: center;
  display: flex;
  ${(props) =>
    props.hasShadow &&
    `
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  `}
`

export const StyleFlexColumnCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  justify-content: center;

  @media (max-width: 640px) {
    gap: 16px;
  }
`
